module.exports = __webpack_public_path__ + "static/img/logo_2_white_text.d61225c.96e8ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_2_white_text.d61225c.png
// module id = Mvr3
// module chunks = 26